import * as Sentry from "@sentry/react";

import { publicConfig } from "@/config/public-config";

import { sentryOptionsFor } from "./sentry-options";

let initialized = false;

export function initSentry(): void {
  if (initialized) return;
  if (!publicConfig.SENTRY_DSN) {
    // No DSN configured — Sentry is a no-op. Local dev path.
    initialized = true;
    return;
  }
  const opts = sentryOptionsFor(publicConfig.SENTRY_ENVIRONMENT);
  Sentry.init({
    dsn: publicConfig.SENTRY_DSN,
    environment: publicConfig.SENTRY_ENVIRONMENT,
    release: publicConfig.RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: opts.maskAllText,
        blockAllMedia: opts.blockAllMedia,
      }),
    ],
    tracesSampleRate: opts.tracesSampleRate,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      // PII scrub: drop cookies from request breadcrumbs.
      if (event.request?.cookies) delete event.request.cookies;
      return event;
    },
  });
  initialized = true;
}

export { Sentry };
